// eslint-disable-next-line
import React from "react";
import { Link } from "react-router-dom";

const Cancel = () => {
  return (
    <div className="bg-gray-100 h-full p-8 mt-8 container m-auto flex justify-center items-center rounded-md">
      <div className="bg-white p-6 w-[400px] md:mx-auto">
        <svg
          viewBox="0 0 24 24"
          className="text-red-600 w-16 h-16 mx-auto my-6"
        >
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm3.536,7.05a1,1,0,0,1,1.414,1.414L13.414,12l3.536,3.536a1,1,0,1,1-1.414,1.414L12,13.414,8.464,16.95a1,1,0,0,1-1.414-1.414L10.586,12,7.05,8.464A1,1,0,0,1,8.464,7.05L12,10.586Z"
          ></path>
        </svg>

        <div className="text-center">
          <h3 className="md:text-2xl text-base py-2 text-red-500 font-semibold text-center">
            Payment Canceled
          </h3>

          <div className="py-5 text-center justify-center flex">
            <Link
              to="/cart"
              className="w-[50%] flex items-center rounded-ee-3xl  justify-center text-white bg-main-background font-bold px-4 py-2 transition-all duration-300 ease-in-out  rounded-sm  hover:bg-red-600"
            >
              Go Back
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
